export const baseThemeSx = {
  bgcolor: "background.default",
  color: "text.primary",
};

// Words that should render fully uppercase (acronyms) instead of just title-cased.
const TITLE_CASE_ACRONYMS = new Set(["it", "id"]);

export const underscoreToTitleCase = (text: string) =>
  text
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((word) =>
      TITLE_CASE_ACRONYMS.has(word.toLowerCase())
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");

export const getLocalStorageItem = (key: string) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

export const setLocalStorageItem = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};


export { decodeHtmlEntities } from "./dom-utils";

